import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { getUidStr } from '../utils/uid';
import { paginationClass } from './styles';
import Input from '../Input';
import { getDirectionClass } from '../utils/classname';
var inputStyle = {
  width: 60,
  display: 'inline-block'
};

var nofunc = function nofunc() {};

var Jumper =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Jumper, _PureComponent);

  var _super = _createSuper2(Jumper);

  function Jumper(props) {
    var _this;

    _classCallCheck(this, Jumper);

    _this = _super.call(this, props);
    _this.renderRequire = void 0;
    _this.autoFocus = void 0;
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.renderRequire = getUidStr();
    return _this;
  }

  _createClass(Jumper, [{
    key: "getMax",
    value: function getMax() {
      var _this$props = this.props,
          total = _this$props.total,
          pageSize = _this$props.pageSize;
      return Math.ceil(total / pageSize) || 1;
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      if (e.keyCode === 13) {
        var current = parseInt(e.target.value, 10);
        this.autoFocus = true;
        if (!Number.isFinite(current)) return;
        if (current < 1) current = 1;
        this.renderRequire = getUidStr();
        var max = this.getMax();
        if (current > max) current = max;

        if (current === this.props.current) {
          this.forceUpdate();
        }

        this.props.onChange(current);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          current = _this$props2.current,
          text = _this$props2.text,
          size = _this$props2.size,
          isSimple = _this$props2.isSimple;
      var txt = text.jumper ? text.jumper.split('{input}') : [];

      if (isSimple) {
        var spanClass = paginationClass('simple-span');
        txt = [[], [
        /*#__PURE__*/
        React.createElement("span", {
          key: "separator",
          className: spanClass
        }, "/"),
        /*#__PURE__*/
        React.createElement("span", {
          key: "pageMax",
          className: spanClass
        }, this.getMax())]];
      }

      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: paginationClass(getDirectionClass('section'))
        }, txt[0] ?
        /*#__PURE__*/
        React.createElement("span", null, txt[0]) : undefined,
        /*#__PURE__*/
        React.createElement(Input, {
          key: this.renderRequire,
          value: String(current),
          onChange: nofunc,
          autoFocus: this.autoFocus,
          onKeyDown: this.handleKeyDown,
          digits: 0,
          type: "number",
          style: inputStyle,
          size: size,
          className: paginationClass(isSimple && 'simple-input'),
          delay: 400
        }), txt[1] ?
        /*#__PURE__*/
        React.createElement("span", null, txt[1]) : undefined)
      );
    }
  }]);

  return Jumper;
}(PureComponent);

export default Jumper;